import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import posts, { getCategories } from './posts';
import { BlogSEO } from './BlogSEO';
import './Blog.css';

function BlogIndex() {
  const categories = getCategories();
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All'
    ? posts
    : posts.filter(p => p.category === activeCategory);

  return (
    <>
      <BlogSEO
        title="Blog — Rentual"
        description="Guides, insights, and product updates for Canadian landlords. Learn about tenant screening, Ontario tenancy law, rent collection, and property management."
        url="https://rentual.co/blog"
      />
      <main className="App-main blog-page">
        <div className="blog-container">
          <header className="blog-header">
            <h1>Insights</h1>
            <p className="blog-subtitle">
              Guides, analysis, and product updates for Canadian landlords.
            </p>
          </header>

          {/* Category filter */}
          <div className="blog-categories">
            <button
              className={`blog-category-btn ${activeCategory === 'All' ? 'active' : ''}`}
              onClick={() => setActiveCategory('All')}
            >
              All
            </button>
            {categories.map(cat => (
              <button
                key={cat}
                className={`blog-category-btn ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => setActiveCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Post grid */}
          <div className="blog-grid">
            {filtered.map(post => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-card">
                {post.image && (
                  <div className="blog-card-image">
                    <img src={post.image} alt={post.title} loading="lazy" />
                  </div>
                )}
                <div className="blog-card-body">
                  <div className="blog-card-meta">
                    <span className="blog-card-category">{post.category}</span>
                    <span className="blog-card-date">
                      {new Date(post.publishedAt).toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' })}
                    </span>
                  </div>
                  <h2 className="blog-card-title">{post.title}</h2>
                  <p className="blog-card-desc">{post.description}</p>
                  <div className="blog-card-footer">
                    <span className="blog-card-read-time">{post.readTime}</span>
                    <span className="blog-card-arrow">→</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filtered.length === 0 && (
            <p className="status-text" style={{ textAlign: 'center', marginTop: '2rem' }}>
              No posts in this category yet.
            </p>
          )}
        </div>
      </main>
    </>
  );
}

export default BlogIndex;
